import { render, staticRenderFns } from "./CheckoutDomainsConfig.vue?vue&type=template&id=000b8c18&"
import script from "./CheckoutDomainsConfig.vue?vue&type=script&lang=js&"
export * from "./CheckoutDomainsConfig.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutDomainsConfig.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports